import { createContext, useContext } from 'react';
import type {
  ContactDetailsConfigContextValue,
  ContactDetailsDataContextValue,
  ContactDetailsStateContextValue,
} from './types';

const stateContext = createContext<ContactDetailsStateContextValue>(
  {} as ContactDetailsStateContextValue
);
const configContext = createContext<ContactDetailsConfigContextValue>(
  {} as ContactDetailsConfigContextValue
);
const dataContext = createContext<ContactDetailsDataContextValue>(
  {} as ContactDetailsDataContextValue
);

export const ContactDetailsStateProvider = stateContext.Provider;
export const ContactDetailsConfigProvider = configContext.Provider;
export const ContactDetailsDataProvider = dataContext.Provider;

export const useContactDetailsState = () => useContext(stateContext);
export const useContactDetailsConfig = () => useContext(configContext);
export const useContactDetailsData = () => useContext(dataContext);
